export const getProductTypeName = (num, amount = 1) => {

  switch(Number(num)) {
    case 0:
      return `Day Pass${amount > 1 ? 'es' : ''}`;
    case 1:
      return `Cabana${amount > 1 ? 's' : ''}`;
    case 2:
      return `Spa Pass${amount > 1 ? 'es' : ''}`;
    case 3:
      return `Daybed${amount > 1 ? 's' : ''}`;
    case 4:
      return `Addon${amount > 1 ? 's' : ''}`;
    case 5:
      return `Fitness Pass${amount > 1 ? 'es' : ''}`;
    case 6:
      return `Event${amount > 1 ? 's' : ''}`;
    case 7:
      return `Beach Day Pass${amount > 1 ? 'es' : ''}`;
    case 8:
      return `Pool and Beach Day Pass${amount > 1 ? 'es' : ''}`;
    default:
      return `Day Pass${amount > 1 ? 'es' : ''}`;
  }
};
